import DeXParaRepository from "@/repositories/dexpara/ResultRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'result',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await DeXParaRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.exams)
            })
            commit('setLoading', false)
        },
    }
}
